import React, { useEffect, useState } from "react";
import { TextField, Typography, Button, FormHelperText } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate, useLocation } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import {
  sendMobileNoAPICall,
  locationCheckAPICall,
  AdminLoginToClientAccountAPICall,
  reSendMobileOTPAPICall,
  validateMobileOTPAPICall,
  SaveIpAddressAPICall,
} from "../shared/APICalls";
import {
  IAdminLogin,
  IMobile,
  IMobileOtpValidation,
  IReSendMobileOTP,
  ISaveIPaddress,
} from "../shared/dtos";
import routesData from "../shared/routes.json";
import SignupStyles from "../pages/Styles/SignUp.module.scss";
import SnackBar from "../Components/SnackBars/SnackBar";
import Checkboxempty from "../Components/assets/Images/Checkboxempty.svg";
import Checkboxdone from "../Components/assets/Images/Checkbox_blue.svg";
import TagManager from "react-gtm-module";
import { TransitionProps } from "@mui/material/transitions";
import SucessSnackBar from "../Components/SnackBars/SucesssnackBar";
import LeftComp from "../Components/LeftComp/LeftComp";

import fstlogo from "../Components/assets/Images/firstockLogoBadge.svg";
import GooglePlayStore from "../Components/assets/Images/GooglePlayStore.svg";
import AppStore from "../Components/assets/Images/AppStore.svg";
import MicroSoft from "../Components/assets/Images/MicrosoftStore.svg";
import leftcompimage from "../Components/assets/Images/SignupIllustration.svg";
import LeftCompNew from "../Components/LeftCompNew/LeftCompNew";
import { isMobile } from "react-device-detect";
import { REFERURL } from "../shared/constants";

const dots = ["1", "2", "3", "4", "5", "6"];

export default function SignupPage() {
  const navigate = useNavigate();
  const [userDeniedLocation, setuserDeniedLocation] = useState(false);
  const [isSafari, setisSafari] = useState(false);
  const [isFireFox, setisFireFox] = useState(false);
  const [loading, setloading] = useState(false);
  const [getloading, setGetloading] = useState(false);
  const [showContent, setshowContent] = useState(true);
  const [message, setMessage] = useState("");
  const [loadingcontent, setloadingcontent] = useState(true);
  const [sebiCheck, setsebiCheck] = useState(false);
  const [IPAddress, setIPAddress] = useState("");
  const [latitude, setlatitude] = useState("");
  const [longitude, setlongitude] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const navigationData = routesData;
  const [countdown, setCountdown] = useState<any>(30);
  const urlParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlParams.entries());
  const source = Object.keys(params)[0];
  const id = (params.c && params.c) || (params.p && params.p);
  const userAgent = navigator.userAgent;
  const [timerId, setTimerId] = useState<any>(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const getSystemTheme = () =>
    window.matchMedia("(prefers-color-scheme: dark)").matches
      ? "dark"
      : "light";
  const [mode, setMode] = useState(getSystemTheme());

  useEffect(() => {
    setMode(getSystemTheme());
  }, [getSystemTheme]);

  const client_id = params.client_id;
  const user_id = params.user_id;

  if (source) {
    sessionStorage.setItem("source", source);
    sessionStorage.setItem("id", id);
  }

  useEffect(() => {
    window.scrollTo(0, 0);

    // const fetchIPAddress = async () => {
    //   try {
    //     const response = await axios.get(
    //       "https://ipapi.co/json/?key=jmJoC4fsM8a1wzvqBWZsEBfRiXtQqsTtz4XdAXaDb27gq2s9QJ"
    //     );
    //     setIPAddress(response.data?.ip);
    //   } catch (err: any) {}
    // };
    // fetchIPAddress();
  }, []);

  useEffect(() => {
    if (isMobile) {
      const referralCode = new URLSearchParams(window.location.search).get("c");
      const referralCodePartner: any = new URLSearchParams(
        window.location.search,
      ).get("p");
      const appUrl: any = new URL(`${REFERURL}`);

      if (referralCode) {
        appUrl.searchParams.set("c", referralCode);
      } else if (referralCodePartner) {
        appUrl.searchParams.set("p", referralCodePartner);
      }

      window.location.replace(appUrl.toString());
    }
  }, []);

  useEffect(() => {
    locationCheckAPICall()
      .then((response: any) => {
        if (response.data.data) {
          setlatitude(response.data.data.latitude);
          setlongitude(response.data.data.longitude);
          sessionStorage.setItem("latitude", response.data.data.latitude);
          sessionStorage.setItem("longitude", response.data.data.longitude);
        }
        if (response.data.data.status === false) {
          setshowContent(false);
        }
      })
      .catch((error: any) => {
        // console.log("error", error);
        setshowContent(false);
      });
  }, []);

  useEffect(() => {
    if (client_id && client_id) {
      let obj: IAdminLogin = {
        client_id: client_id,
        admin_id: user_id,
      };

      AdminLoginToClientAccountAPICall(obj)
        .then((response: any) => {
          const responseData = response.data;
          sessionStorage.setItem(
            "access-token",
            responseData.data.access_token,
          );
          if (
            responseData.data.next_stage &&
            navigationData.hasOwnProperty(responseData.data.next_stage)
          ) {
            navigate(navigationData[responseData.data.next_stage]);
          }
        })
        .catch((error: any) => {
          setMessage(error.response.data.message);
          setTimeout(() => {
            setMessage("");
          }, 5000);
        });
    }
  }, [client_id, user_id]);

  useEffect(() => {
    // setIsButtonDisabled(true);
    // setCountdown(30);
    // if (timerId === null) {
    //   let interval = setInterval(() => {
    //     setCountdown((prevCountdown) => prevCountdown - 1);
    //   }, 1000);
    //   setTimerId(interval);
    // }
  }, []);
  useEffect(() => {
    if (countdown <= 0 && timerId !== null) {
      setIsButtonDisabled(false);

      clearInterval(timerId);
      setTimerId(null);
    }
  }, [countdown]);

  function sendMobileNumber(data: any) {
    TagManager.dataLayer({
      dataLayer: {
        event: "formSubmitMobile",
        phone: data,
      },
    });

    setGetloading(true);
    let obj: IMobile = {
      mobile: data,
      ip_address: IPAddress?.trim(),
      device_type: userAgent?.toString(),
    };
    sendMobileNoAPICall(obj)
      .then((response: any) => {
        const responseData = response.data;

        setGetloading(false);
        sessionStorage.setItem("mobile", data);
        setSuccessMessage("Successfully sent the OTP to your Mobile.");
        setTimeout(() => {
          setSuccessMessage("");
        }, 5000);

        if (
          responseData.data.next_stage &&
          navigationData.hasOwnProperty(responseData.data.next_stage)
        ) {
          navigate(navigationData[responseData.data.next_stage]);
        }
      })
      .catch((error: any) => {
        setGetloading(false);
        setOtpSent(false);
        setMessage(
          error.message.includes("Network")
            ? "Error occured, Please try again"
            : error.response.data.message,
        );
        setTimeout(() => {
          setMessage("");
        }, 5000);
      });
  }

  function validatePhoneNumber(value: any) {
    let error: any;
    if (!value) {
      error = "Mobile Number Required";
    } else if (!/^[0-9]{10}$/.test(value)) {
      error = "Must be a valid 10 digit mobile number";
    }
    return error;
  }

  useEffect(() => {
    setTimeout(() => {
      setloadingcontent(false);
    }, 1000);
    const listener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        // console.log("Enter key was pressed. Run your function.");
        const onFormSubmit = (values) => {
          sendMobileNumber(values.phoneNumber);
        };

        event.preventDefault();
        // callMyFunction();
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, []);

  return (
    <>
      <SnackBar message={message} />
      <SucessSnackBar message={successMessage} />
      <div className={SignupStyles.layout}>
        <div className={SignupStyles.sidebar}>
          <LeftCompNew />
        </div>
        <div className={SignupStyles.pageContent}>
          <div className={SignupStyles.wrapper}>
            <div className={SignupStyles.RightContainer}>
              <div className={SignupStyles.contentSection}>
                <div className={SignupStyles.headerSection}>
                  <img
                    src={fstlogo}
                    alt=""
                    className={SignupStyles.fstlogo}
                    // style={{
                    //   filter:
                    //     mode === "dark"
                    //       ? "grayscale(0.9) invert(0.9) brightness(1)"
                    //       : "",
                    // }}
                  />
                  <p className={SignupStyles.signup}>Welcome to Firstock</p>
                  <p className={SignupStyles.subText}>
                    Sign in, or open a new account
                  </p>
                </div>

                <div className={SignupStyles.imageContainer}>
                  <LeftCompNew />
                </div>

                {showContent ? (
                  <Formik
                    initialValues={{
                      phoneNumber: "",
                    }}
                    onSubmit={(values) => {
                      if (latitude === "") {
                        setMessage("Location details not found");
                        setTimeout(() => {
                          setMessage("");
                        }, 5000);
                      } else {
                        // sendMobileNumber(values.phoneNumber);
                        sendMobileNumber(values.phoneNumber);
                      }
                    }}
                  >
                    {({
                      errors,
                      touched,
                      handleChange,
                      values,
                      handleSubmit,
                      setFieldValue,
                    }) => (
                      <Form
                        onKeyDown={(event) => {
                          event.code === "Enter" && handleSubmit();
                        }}
                        style={{ width: "98%" }}
                      >
                        {!userDeniedLocation ? (
                          <div style={{ width: "100%" }}>
                            <div className={SignupStyles.labeltext}>
                              Mobile Number
                            </div>
                            <Field
                              name="phoneNumber"
                              validate={validatePhoneNumber}
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  autoComplete="off"
                                  label=""
                                  type="numeric"
                                  sx={{
                                    fieldset: {
                                      borderColor: "#E5E7EB",
                                    },
                                  }}
                                  placeholder="Enter Mobile Number"
                                  className={SignupStyles.textfield}
                                  variant="outlined"
                                  value={values.phoneNumber}
                                  onChange={handleChange}
                                  inputProps={{
                                    sx: {
                                      "&::placeholder": {
                                        paddingLeft: "-40px",
                                        color: "var(--ds-text-secondary)",
                                        fontWeight: 400,
                                        fontStye: "normal",
                                        fontSize: "14px",
                                      },

                                      paddingLeft: "-40px",
                                    },
                                    maxLength: 10,
                                    inputMode: "numeric",
                                    pattern: "[0-9]*",
                                  }}
                                  onKeyPress={(event) => {
                                    const keyCode =
                                      event.keyCode || event.which;
                                    const keyValue =
                                      String.fromCharCode(keyCode);
                                    const isValidKey = /^\d+$/.test(keyValue);

                                    if (!isValidKey) {
                                      event.preventDefault();
                                    }
                                  }}
                                />
                              )}
                            />

                            <FormHelperText
                              style={{
                                color: "#d32f2f",
                                height: "10px",
                                marginTop: "3px",
                                // marginLeft: "0px",
                                // textAlign: "center",
                              }}
                            >
                              {errors.phoneNumber &&
                                touched.phoneNumber &&
                                errors.phoneNumber}
                            </FormHelperText>

                            {/* <p className={SignupStyles.smallText}>
                              You will receive an OTP on your number
                            </p> */}

                            {/* <FormGroup
                              sx={{ marginLeft: "0px", marginTop: "30px" }}
                            >
                              <FormControlLabel
                                sx={{ alignItems: "start" }}
                                control={
                                  <Checkbox
                                    name="fatcacondition1"
                                    sx={{
                                      padding: "0px",
                                      width: "20px",
                                      height: "20px",
                                      marginTop: "6px",
                                    }}
                                    checked={sebiCheck}
                                    icon={<img src={Checkboxempty} />}
                                    checkedIcon={<img src={Checkboxdone} />}
                                  />
                                }
                                onChange={(event: any) => {
                                  const { checked } = event.target;
                                  setsebiCheck(checked);
                                }}
                                label={
                                  <span
                                    className={SignupStyles.smallTextCheckBox}
                                    style={{ padding: 0 }}
                                  >
                                    I express my consent in opening online KYC
                                    process
                                  </span>
                                }
                              />
                            </FormGroup> */}

                            <div className={SignupStyles.descriptionMobile}>
                              <div className={SignupStyles.text1}>
                                Firstock Broking (P) Ltd: NSE & BSE - SEBI
                              </div>
                              <div className={SignupStyles.text1}>
                                Registration No. INZ000260334
                                | CDSL - SEBI Registration No : IN-
                              </div>
                              <div className={SignupStyles.text1}>
                                DP-67-2015 | Mutual Fund ARN: 132812 | Smart
                                Online Dispute
                              </div>
                              <div className={SignupStyles.text1}>
                                Resolution | SEBI SCORES
                              </div>
                            </div>

                            <div className={SignupStyles.buttonSection}>
                              <LoadingButton
                                variant="contained"
                                type="submit"
                                loading={getloading}
                                id="signupContinueButton"
                                className={SignupStyles.button}
                                onClick={() => {
                                  handleSubmit();
                                }}
                                disabled={
                                  values.phoneNumber?.length !== 10
                                    ? true
                                    : false
                                }
                              >
                                Continue
                              </LoadingButton>
                            </div>
                          </div>
                        ) : (
                          <>
                            <div>
                              <Typography>
                                Location Access is blocked, please grant the
                                Loaction access in browser settings to proceed
                                further{" "}
                              </Typography>
                            </div>
                            {isFireFox && (
                              <div>
                                <Button
                                  variant="outlined"
                                  onClick={() => {
                                    window.location.reload();
                                  }}
                                  id="signupReloadButton"
                                >
                                  Reload
                                </Button>
                              </div>
                            )}
                            {isSafari ? (
                              <div>
                                <Typography>
                                  Please Press Reload Button after granting
                                  camera access
                                </Typography>
                                <Button
                                  variant="outlined"
                                  onClick={() => {
                                    window.location.reload();
                                  }}
                                  id="signupSafariReloadButton"
                                >
                                  Reload
                                </Button>
                              </div>
                            ) : (
                              ""
                            )}
                          </>
                        )}
                      </Form>
                    )}
                  </Formik>
                ) : (
                  <div
                    // marginTop={'150px'}
                    style={{
                      minHeight: "200px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    Access Allowed Only in India{" "}
                  </div>
                )}
              </div>
            </div>

            <div className={SignupStyles.cardFooter}>
              <div className={SignupStyles.footerLinks}>
                <a
                  className={SignupStyles.footerItem}
                  href="https://firstock.in/faq/"
                  target="_blank"
                  rel="noreferrer"
                >
                  FAQ
                </a>
                <span className={SignupStyles.footerSep} aria-hidden="true">
                  ·
                </span>
                <a
                  className={SignupStyles.footerItem}
                  href="https://firstock.in/support/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Support
                </a>
              </div>

              <p className={SignupStyles.termsAck}>
                By continuing, you agree to our{" "}
                <a
                  href="https://firstock.in/terms"
                  target="_blank"
                  rel="noreferrer"
                >
                  Terms
                </a>{" "}
                &amp;{" "}
                <a
                  href="https://firstock.in/privacy"
                  target="_blank"
                  rel="noreferrer"
                >
                  Privacy Policy
                </a>
                .
              </p>
            </div>
            {/* <div className={SignupStyles.firstockApps}>
              <div className={SignupStyles.apps}>
                <a
                  href="https://play.google.com/store/apps/details?id=in.firstock.mobile"
                  target="_blank"
                >
                  <img
                    src={GooglePlayStore}
                    className={SignupStyles.Googlestoreimage}
                  />
                </a>

                <a
                  href="https://apps.apple.com/us/app/firstock-trade-invest/id6746480444"
                  target="_blank"
                >
                  <img src={AppStore} className={SignupStyles.Appstoreimage} />
                </a>

                <a href="https://firstock-common.s3.ap-south-1.amazonaws.com/app/Firstock_INV_Live_Firstock_2023.7.4-setup.zip">
                  <img
                    src={MicroSoft}
                    className={SignupStyles.Microstoreimage}
                  />
                </a>
              </div>
              <div className={SignupStyles.description}>
                <div className={SignupStyles.text1}>
                  Firstock Broking (P) Ltd: NSE & BSE - SEBI
                </div>
                <div className={SignupStyles.text1}>
                  Registration No. INZ000260334 | CDSL - SEBI Registration No :
                  IN-
                </div>
                <div className={SignupStyles.text1}>
                  DP-67-2015 | Mutual Fund ARN: 132812 | Smart Online Dispute
                  Resolution | SEBI SCORES
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
